// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"426":"b50982838ebba65ee18e","748":"a2066e6edc8b2645e1ff","968":"5c8ee94c739e32e988d7"}[chunkId] + ".css";
};